<template>
  <a-card>
    <div style="float: right;">
      <div class="table-toolbar">
        <a-button type="primary" @click="onEdit">
          <template #icon>
            <form-outlined />
          </template>
        </a-button>
      </div>
    </div>
    <a-descriptions bordered :column="2">
      <a-descriptions-item label="期望职位">
        <dict-render :dict-obj="dictObjs['hope_job']" v-if="detail.jobTitleExpectation"
          :text="detail.jobTitleExpectation"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="期望城市">{{ detail.provject }}</a-descriptions-item>
      <a-descriptions-item label="期望薪资">
        <dict-render :dict-obj="dictObjs['salary']" v-if="detail.salaryExpectation"
          :text="detail.salaryExpectation"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="期望从事行业">
        <dict-render :dict-obj="dictObjs['research_field']" v-if="detail.businessExpectation"
          :text="detail.businessExpectation"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="入职时间">{{ detail.estimatedTimeEntry ? detail.estimatedTimeEntry.split(' ')[0] : ''
      }}</a-descriptions-item>
      <a-descriptions-item label="工作性质">
        <dict-render :dict-obj="dictObjs['work_type']" v-if="detail.natureWork" :text="detail.natureWork"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="目前工作状态">
        <dict-render :dict-obj="dictObjs['work_status']" v-if="detail.stateWork" :text="detail.stateWork"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="期望展示效果">
        <dict-render :dict-obj="dictObjs['hope_show']" v-if="detail.displayEffect"
          :text="detail.displayEffect"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="自我评价">{{ detail.selfEvaluation }}</a-descriptions-item>
    </a-descriptions>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="getInfo" />
</template>

<script>
import { dictMixin } from "@/mixins";
import UserModal from './components/UserModal';
import { employmentIntentionInfo } from "@/api/educationService";
import DictRender from "@/components/other/DictRender";
import { showCity } from "@/utils/util";

export default {
  name: "index",
  mixins: [dictMixin],
  components: {
    UserModal, DictRender
  },
  data() {
    return {
      dictNames: 'hope_job,salary,research_field,work_type,work_status,hope_show',
      detail: {},
      listKeyField: "id",
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.getAction({
        url: employmentIntentionInfo.detail
      }).then(res => {
        this.detail = {
          ...res,
          provject: res.prov ? showCity(res.prov, res.city, res.dist) : ''
        }
      })
    },
    onEdit() {
      this.getAction({
        url: employmentIntentionInfo.detail
      }).then(res => {
        this.onShowModal('userModal', res);
      })
    },
    onShowModal(refName, data = {}) {
      const refEle = this.$refs[refName];
      refEle.form = Object.assign({}, data);
      refEle.visible = true;
    },
  }
}
</script>

<style scoped lang="less"></style>
